module.exports = __webpack_public_path__ + "img/arrow_right.72dfc506.svg";